export default __webpack_public_path__ + "static/media/git.f7d62831.svg";